// Mock data for Auracrest Haven clone (frontend-only)

export const LOGO = "/assets/auracrest_logo.png";

export const HERO_IMAGE = "https://images.unsplash.com/photo-1658051161493-1d311c4c7b4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxNdW5uYXIlMjB0ZWElMjBoaWxsc3xlbnwwfHx8fDE3ODgzMjcxNDZ8MA&ixlib=rb-4.1.0&q=85";

export const NEARBY_PLACES = [
  "Anachal", "Sengulam", "Muthuvankudy", "Vellathooval", "Kunjithanni",
  "Etty City", "Shankupadi", "Thokkupara", "Elkunnu", "Plantum Padi",
  "Ellakkal", "Kuthupara", "Pothupara", "Selliampara", "Maryland",
  "Kumminikunn", "Amakandam", "Pallivasal", "2nd Mile", "Chithirapuram",
  "Meencut", "Bison Valley",
];

export const PROPERTY_GALLERY = [
  { src: "/assets/prop_aframe_exterior.webp", alt: "A-frame cottages at Auracrest Haven near Anachal, Munnar", caption: "A-Frame Cottages" },
  { src: "/assets/prop_aframe_view.webp", alt: "Auracrest Haven cottages with hilltop cafe and forest views", caption: "Cottages & Hilltop Cafe" },
  { src: "/assets/prop_room_balcony.webp", alt: "Deluxe room with private balcony and garden view", caption: "Deluxe Room with Balcony" },
  { src: "/assets/prop_room_wide.webp", alt: "Spacious well-lit bedroom with king bed and seating", caption: "Spacious Rooms" },
  { src: "/assets/prop_king_bed.webp", alt: "Comfortable king bed with fresh linen", caption: "King Bed Comfort" },
  { src: "/assets/prop_room_a2_1.webp", alt: "Ground floor family room at Auracrest Haven", caption: "Ground Floor Room" },
  { src: "/assets/prop_room_a2_2.webp", alt: "Cozy cottage interior with modern furnishings", caption: "Cottage Interior" },
  { src: "/assets/prop_bathroom.webp", alt: "Modern bathroom with rain shower and 24-hour hot water", caption: "Modern Bathrooms" },
];

export const CAMPFIRE_IMAGE = "https://images.unsplash.com/photo-1475483768296-6163e08872a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxjYW1wZmlyZSUyMG5pZ2h0fGVufDB8fHx8MTc4ODMyNzE0Nnww&ixlib=rb-4.1.0&q=85";

export const NAV_LINKS = [
  { label: "Home", href: "/#home" },
  { label: "About", href: "/#about" },
  { label: "Dining", href: "/#dining" },
  { label: "Attractions", href: "/#attractions" },
  { label: "Facilities", href: "/#facilities" },
  { label: "Our Resorts", href: "/#resorts" },
  { label: "Contact", href: "/#contact" },
  { label: "Privacy Policy", href: "/privacy_policy.html" },
];

export const ATTRACTIONS = [
  {
    title: "Jeep Safari",
    desc: "Explore the rugged terrain of Munnar in a sturdy jeep",
    img: "https://www.auracresthaven.com/images/photo-1729880481231-e4434f18e3e2.jpeg",
  },
  {
    title: "Zip Line",
    desc: "Get your adrenaline pumping with a thrilling zip line experience",
    img: "https://www.auracresthaven.com/images/photo-1684678255258-462f9c70db53.jpeg",
  },
  {
    title: "Glass Bridge",
    desc: "Test your courage on our glass bridge and enjoy the stunning views below",
    img: "https://www.auracresthaven.com/images/photo-1661558129210-70184a92710e.jpeg",
  },
  {
    title: "Hot Air Balloon",
    desc: "Soar above the trees and take in breathtaking views of the landscape",
    img: "https://images.unsplash.com/photo-1516571458377-3877970b7aaf?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080",
  },
  {
    title: "Kathakali Dance",
    desc: "Explore the rich culture and heritage of Kerala with Kathakali performances, a traditional dance form",
    img: "https://images.unsplash.com/photo-1729079113875-b27ba7bb7525?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080",
  },
  {
    title: "Kalaripayattu",
    desc: "A martial art that showcases the region's ancient traditions",
    img: "/assets/kalaripayattu.png",
  },
  {
    title: "Sunrise View Point",
    desc: "Wake up early and witness the breathtaking sunrise from our hilltop view point",
    img: "https://www.auracresthaven.com/images/photo-1644081915830-46fffb42e76d.jpeg",
  },
  {
    title: "Tea Garden Visit",
    desc: "Learn about the tea-making process and sample some of the finest teas",
    img: "https://www.auracresthaven.com/images/photo-1742286087579-fcaa5ed24c35.jpeg",
  },
  {
    title: "Spice Garden Visit",
    desc: "Explore the aromatic world of cardamom, nutmeg, and more.",
    img: "https://images.unsplash.com/photo-1668916938366-dd16c56719e8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080",
  },
  {
    title: "Botanical Garden",
    desc: "Explore the lush gardens and learn about the local flora",
    img: "https://www.auracresthaven.com/images/photo-1676947296618-2dcb62ea95c1.jpeg",
  },
  {
    title: "Sengulam Dam",
    desc: "Enjoy a relaxing boat ride on the tranquil waters of Sengulam Dam",
    img: "https://images.unsplash.com/photo-1714268508727-674c40fbca66?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080",
  },
  {
    title: "Waterfalls",
    desc: "Explore the nearby waterfalls and enjoy a refreshing dip",
    img: "https://images.unsplash.com/photo-1638476659064-c3bbdadb75ff?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080",
  },
  {
    title: "Nilgiri Thar",
    desc: "Catch a glimpse of the endangered Nilgiri Thar, a majestic species of goat",
    img: "https://images.unsplash.com/photo-1574423886860-a27bb1814f28?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080",
  },
  {
    title: "Munnar Ghat Roads",
    desc: "Take a drive or cycle through the scenic ghat roads and enjoy the stunning views",
    img: "https://www.auracresthaven.com/images/photo-1672219386269-486cbbe9a50f.jpeg",
  },
  {
    title: "Boating",
    desc: "Glide across the calm backwaters and enjoy a peaceful boating experience in Munnar",
    img: "https://images.unsplash.com/photo-1714268508727-674c40fbca66?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080",
  },
  {
    title: "Kolukkumalai Sunrise",
    desc: "Journey to the world's highest tea plantation for an unforgettable Kolukkumalai sunrise",
    img: "https://images.unsplash.com/photo-1658051161493-1d311c4c7b4d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080",
  },
  {
    title: "Elephant View",
    desc: "Spot majestic wild elephants roaming the forests and plantations around Munnar",
    img: "https://images.unsplash.com/photo-1557050543-4d5f4e07ef46?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080",
  },
  {
    title: "Wildlife & Jungle Safari",
    desc: "Explore the rich biodiversity of the Western Ghats on a thrilling jungle safari",
    img: "https://images.unsplash.com/photo-1549366021-9f761d450615?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080",
  },
  {
    title: "Sightseeing Tours",
    desc: "Discover Munnar's iconic viewpoints, dams and landmarks with guided sightseeing tours",
    img: "https://images.unsplash.com/photo-1711192702535-eac61a78ecb0?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080",
  },
];

export const SAFETY_POINTS = [
  "Embrace the tranquil setting, where safety and comfort intertwine for a memorable stay.",
  "Experience safety and comfort in our homestay, designed to cater to your relaxation needs.",
  "Ideal for solo travelers too, enjoy the peaceful environment, fresh air, and cool climate.",
  "The homestay offers modern, plush rooms with ample parking, perfect for families or friends.",
];

export const CLEAN_FEATURES = [
  {
    title: "Safe Environment for Guests",
    desc: "Within a 3 km radius, guests have easy access to hospitals, medical shops, police station, and places of worship.",
  },
  {
    title: "Peace of Mind with CCTV",
    desc: "Our property boasts a fully secured fencing, ensuring a safe environment for all guests.",
  },
  {
    title: "Emergency Exit Gates",
    desc: "Our pathways are designed to allow vehicles near the doorstep and accommodate emergency vehicles.",
  },
];

export const CLEAN_IMAGES = [
  "https://www.auracresthaven.com/images/photo-1593007791459-4b05e1158229.jpeg",
  "https://www.auracresthaven.com/images/photo-1709364531162-6e613646afa8.jpeg",
];

export const SUPPORT_POINTS = [
  "For your local transportation needs, we provide Autorickshaw, Jeep, Cabs, and more options.",
  "Additionally, public and private buses are available from Anachal, just a 10-minute drive away.",
  "When it comes to payments, we accept cash, UPI, all major Credit Cards, and Debit Cards.",
  "Within a 3 km radius, you can enjoy salon and spa services for relaxation.",
];

export const GALLERY = [
  "https://www.auracresthaven.com/images/king_bed.jpg",
  "https://www.auracresthaven.com/images/two_storey_roadside_view.jpg",
  "https://www.auracresthaven.com/images/from_gate_board.jpg",
];

export const HOSTS_IMAGE = "/assets/promoters.jpg";
export const SPYZZZ_LOGO = "https://www.auracresthaven.com/images/spyzzz_logo.png";
export const SPYZZIE_HERO = "/assets/spyzzie_hero.jpg";
export const SPYZZIE_DISHES = [
  { img: "/assets/spyzzie_vegrice.jpg", name: "Veg Fried Rice", price: "₹150", size: "400g" },
  { img: "/assets/spyzzie_chicken65.jpg", name: "Chicken 65 Dry Fry", price: "₹150", size: "150g" },
];
export const SPYZZZ_APP_LOGO = "/assets/spyzzz_app_logo.png";

export const CONTACT = {
  address: "Auracrest Haven, Building No. 5/283, Anachal, Sengulam, Muthuvankudy, Idukki - 685565, Kerala",
  gstin: "32BMQPS3856K1ZD",
  phone: "+91-9388881016",
  whatsapp: "919388881016",
  email: "booking@auracresthaven.com",
};

export const KOCHI = {
  brand: "Morning Star Metro Home Stay Kochi",
  logo: "/assets/morningstar_logo.webp",
  logoSquare: "/assets/morningstar_logo_square.webp",
  tagline: "An urban oasis in the heart of Kochi \u2014 the commercial capital of Kerala.",
  location: "Second lane from Jawaharlal Nehru International Stadium, Kaloor, Kochi (Ernakulam), Kerala",
  phone: "+91-9388881016",
  email: "booking@auracresthaven.com",
};
